import { checkValidateProject, getTxReceipt, importExternalProject, validateProject } from "./axiosRequests/axiosHandlerUtilities";
import { Chain } from "./Chain";
import { CheckValidateProject, GetTxReceipt  } from "./models";
import { ImportExternalProject } from "./models/utilities/importExternalProject";
import { ValidateProject } from "./models/utilities/validateProject";

export class Utilities extends Chain { 
    public getTxReceipt = async (
        payload: GetTxReceipt
    ): Promise<any> => {
        return await getTxReceipt(payload, this.initialize);
    }

    public validateProject = async (
        payload: ValidateProject
    ): Promise<any> => {
        return await validateProject(payload, this.initialize);
    }

    public checkValidate = async (
        payload: CheckValidateProject
    ): Promise<any> => {
        return await checkValidateProject(payload, this.initialize);
    }
    public importProject = async (
        payload: ImportExternalProject
    ): Promise<any> => {
        return await importExternalProject(payload, this.initialize);
    }
}